<template>
    <div>
        <Card>

            <p slot="title">
                {{ marking.markingCode }}
            </p>

            <template slot="extra">
                {{ marking.marketingCode }} &nbsp;
                <Tag color="green">{{ marking.totalReceivableRemaining }} </Tag>
            </template>

            <div v-for="(invoice, idx) in invoicesFormatted" :key="idx">
                <cInvoiceUnSettledByMarkingRow :invoice="invoice"></cInvoiceUnSettledByMarkingRow>
            </div>
        </Card>
    </div>
</template>

<script>
import cInvoiceUnSettledByMarkingRow from '@/components/invoice/cInvoiceUnSettledByMarkingRow'
const numeral = require('numeral');
import moment from 'moment'


export default {
    components: { cInvoiceUnSettledByMarkingRow },
    props: {
        item: Object
    },
    data: () => ({
        notes: [],
        marking: Object,
        invoicesFormatted: []
    }),
    methods: {
        formattingContainer: function () {
            let invoicesFormatted = [];
            let totalReceivableRemaining = 0;
            let totalReceivableRemainingIdr = 0;
            let parent = this;
            let prefixmarking = this.item.markingheadercode.split('/')[0];
            let isSpecialPrefix = (prefixmarking == 'SBR' || prefixmarking == 'SBRT' || prefixmarking == 'CTH')
            let currencyRate = 0;
            let compareDate = new Date('2024-12-01'); // deploy currency sgd

            _.forEach(this.item.invoices, function (value) {
                let receivableRemaining = ''
                let loadDate = ''
                let containerCode = ''
                let totalVolume = ''
                let description = ''
                let receivableRemainingIdr = ''

                if (value.receivable.type == 'MAN') {
                    let transactionDate = new Date(value.receivable.transactionDate);

                    if (transactionDate > compareDate && isSpecialPrefix && value.receivable.isConvert) {
                        currencyRate = value.receivable.currency_sgd.currencyrate
                    }

                    receivableRemaining = value.receivable.debitAmount - value.paymentSum
                    receivableRemainingIdr = receivableRemaining * currencyRate
                    loadDate = parent.showDateFormatted(value.receivable.transactionDate)
                    containerCode = ''
                    totalVolume = ''
                    description = value.receivable.description
                } else {
                    let transactionDate = new Date(value.receivable.invoice.packaging_list.container_loading.arrivaldate);

                    if (transactionDate > compareDate && isSpecialPrefix && value.receivable.isConvert) {
                        currencyRate = value.receivable.invoice.packaging_list.container_loading.currency_sgd.currencyrate
                    }
                    receivableRemaining = value.receivable.invoice.invoicefee - value.paymentSum
                    receivableRemainingIdr = receivableRemaining * currencyRate
                    loadDate = parent.showDateFormatted(value.receivable.invoice.packaging_list.container_loading.loaddate)
                    containerCode = value.receivable.invoice.packaging_list.container_loading.containercode

                    totalVolume = numeral(value.receivable.invoice.totalvolume).format('0.000');
                    description = totalVolume
                }

                let invoice = {
                    loadDate: loadDate,
                    containerCode: containerCode,
                    receivableRemaining: receivableRemaining,
                    receivableRemainingIdr: receivableRemainingIdr,
                    description: description
                }

                totalReceivableRemaining += receivableRemaining;
                totalReceivableRemainingIdr += receivableRemainingIdr;
                invoicesFormatted.push(invoice);

            });
            invoicesFormatted =
                _.sortBy(invoicesFormatted, ['loadDateDate'], function (value) { return new Date(value); });


            this.invoicesFormatted = invoicesFormatted;

            this.marking =
            {
                markingCode: this.item.markingheadercode,
                marketingCode: this.item.invoices[0].receivable.invoice.packaging_list.marking_minified.marketing.marketingname,
                totalReceivableRemaining: numeral(totalReceivableRemaining).format('0,0'),
                totalReceivableRemainingIdr: numeral(totalReceivableRemaining).format('0,0'),
            }

        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("D MMM YYYY")
        }
    },
    created() {

        this.formattingContainer();
    }
}

</script>
<style></style>


// WEBPACK FOOTER //
// cInvoiceUnSettledByMarking.vue?05fdaa58